export default __webpack_public_path__ + "static/media/Tunisia.cea0e38c.png";